import styled, { css } from 'styled-components'

import { minmedia } from '../../styles/media-queries';
import { black, almostblack, gold, bordergray } from '../../styles/colors';

export const StyledLink = styled.div`
  a {
    color: ${almostblack};
    text-decoration: none;
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    &:hover {
      color: ${gold};

      svg {
        fill: ${gold};
      }
    }
  }

  ${props => props.contained && css`
    padding: .75rem 0 .75rem .5rem; 
    border-bottom: 1px solid ${bordergray};

    ${minmedia.medium`
      padding-top: 1rem;
      padding-bottom: 1rem;
    `}
    ${minmedia.xmlarge`
      border-bottom: none;
      padding-top: 1.5rem;
      padding-bottom: 1.5rem;
      padding-left: 215px;
    `}
    ${minmedia.xxlarge`
      padding-left: 250px;
    `}
  `}
`

export const IconContainer = styled.div`
  margin-right: .5rem;
  margin-top: .2rem;

  svg {
    transition: fill .5s;
    height: 1rem;
    width: 1rem;
    fill: ${black};
  }
`


// WEBPACK FOOTER //
// ./src/components/BackLink/styles.js